// Constants for different requests for current reducer
export default {
  performance: 'PERFORMANCE'
};
